import { UserType } from 'Core/interfaces/core'

import { LayoutType } from 'Portals/Customer/constants/layout'

export const LAYOUT_TYPE_USER_TYPE_DEPENDENCIES: {
	[key in UserType]?: LayoutType
} = {
	[UserType.CUSTOMER]: LayoutType.general,
	[UserType.DATA_MANAGEMENT]: LayoutType.general,
	[UserType.NEW_CUSTOMER]: LayoutType.registrationDocument
}
